import { CompareByTimePreview } from '@modules/quantify/components/QuantifyQueryBuilder/QuantifyQueryBuilderPreview/CompareByTimePreview';
import { useGetFormattedDurationFieldLabels } from '@modules/quantify/hooks';
import { useQuantifyStore } from '@modules/quantify/store/quantifyStore';
import { Stack, Typography } from '@mui/material';

export function DurationPreview() {
  const duration = useQuantifyStore(({ query }) => query.duration);
  const compareTo = useQuantifyStore(({ query }) => query.compareQuery);
  const { durationLabel } = useGetFormattedDurationFieldLabels();

  if (compareTo?.timerange || compareTo?.previousPeriod) {
    return <CompareByTimePreview />;
  }

  return (
    <Stack>
      <Typography variant="subtitle1">Duration:</Typography>
      <Typography variant="body2" color="primary">
        {durationLabel.primary}
      </Typography>
      {duration.type === 'last' ? (
        <Typography variant="caption">{durationLabel.secondary}</Typography>
      ) : null}
    </Stack>
  );
}
